import Vue from 'vue';

// TEMPORARY: set false after live testing to restore dashboard 30 / signup 15 minutes.
const SESSION_TEST_MODE = false;
const WARNING_TIME = (SESSION_TEST_MODE ? 1 : 2) * 60 * 1000;

function createSessionMixin(dashboard = false) {
return {
    data () {
        return {
            sessionWarning: false,
            disableSessionTimer: false,
            sessionSeconds: 0,
            sessionExtending: false,
            sessionExtensionFailed: false
        };
    },
    computed: {
        showSessionTimer () { return this.sessionWarning; },
        mins () { return Math.floor(this.sessionSeconds / 60); },
        secs () { return ('0' + this.sessionSeconds % 60).slice(-2); },
        sessionCountdown () {
            const minutes = Math.floor(this.sessionSeconds / 60);
            const seconds = ('0' + this.sessionSeconds % 60).slice(-2);
            return minutes + ':' + seconds;
        }
    },
    created () {
        if (dashboard && (!window.bnJS.loaderVersion || !window.bnJS.loaderVersion.trim() ||
            window.bnJS.currentPage === 'brokerRegistrationLogin')) return;
        this.sessionOptions = {
            dashboard,
            logout: dashboard ? window.bnJS.logout : '/broker-registration/logout/',
            // Apache keeps these paths on BrokersNexus; the generic /api/session-continue/ redirects to Insubuy.
            continueUrl: dashboard ? '/dashboard/myaccount/session-continue/' : '/broker-registration/session-continue/',
            context: dashboard ? 'dashboard' : 'registration'
        };
        const timeout = (SESSION_TEST_MODE ? 2 : dashboard ? 30 : 15) * 60 * 1000;
        const serverTimeout = Number(window.bnJS.sessionTimeout || '0');
        this.registrationTimeout = serverTimeout > 0
            ? Math.min(serverTimeout, timeout) : timeout;
        this.resetRegistrationSession(Date.now());
        this.registrationInterceptor = (request, next) => {
            const url = new URL(request.url, window.location.href);
            const sessionRequest = url.origin === window.location.origin && (dashboard
                ? /^\/(api\/)?(dashboard|panel|caozuomianban|affiliates\/v1)\//.test(url.pathname)
                : /^\/(api\/)?broker-registration\//.test(url.pathname));
            const startedAt = Date.now();
            next(response => {
                if (sessionRequest) {
                    if (response.body === 'session logged out' || (response.body && response.body.loggedOut)) {
                        this.logoutRegistration();
                    } else if (response.ok && response.body && typeof response.body === 'object' &&
                        (dashboard ? response.body.success !== false : response.body.success === true)) {
                        this.resetRegistrationSession(startedAt);
                    }
                }
                return response;
            });
        };
        Vue.http.interceptors.push(this.registrationInterceptor);
        this.registrationInterval = setInterval(this.checkRegistrationSession, 1000);
        document.addEventListener('visibilitychange', this.checkRegistrationSession);
    },
    beforeDestroy () {
        clearInterval(this.registrationInterval);
        document.removeEventListener('visibilitychange', this.checkRegistrationSession);
        const index = Vue.http.interceptors.indexOf(this.registrationInterceptor);
        if (index !== -1) Vue.http.interceptors.splice(index, 1);
    },
    methods: {
        resetRegistrationSession (startedAt) {
            this.registrationDeadline = Math.max(this.registrationDeadline || 0,
                startedAt + this.registrationTimeout);
            this.sessionWarning = false;
            this.disableSessionTimer = false;
            this.sessionExtensionFailed = false;
        },
        checkRegistrationSession () {
            const remaining = this.registrationDeadline - Date.now();
            if (remaining <= 0) {
                this.logoutRegistration();
                return;
            }
            this.sessionSeconds = Math.ceil(remaining / 1000);
            const showWarning = remaining <= Math.min(WARNING_TIME, this.registrationTimeout / 2);
            if (showWarning && !this.sessionWarning) {
                this.$nextTick(() => {
                    if (this.$refs.sessionContinue) this.$refs.sessionContinue.focus();
                });
            }
            this.sessionWarning = showWarning;
        },
        logoutRegistration () {
            clearInterval(this.registrationInterval);
            window.location.href = this.sessionOptions.logout;
        },
        closeTimeout () {
            // Dismissing the shared notice does not pause the expiry deadline.
            this.disableSessionTimer = true;
        },
        resetSessionExpireTime () {
            return this.extendRegistrationSession();
        },
        extendRegistrationSession () {
            if (this.sessionExtending) return;
            if (Date.now() >= this.registrationDeadline) {
                this.logoutRegistration();
                return;
            }
            this.sessionExtending = true;
            this.sessionExtensionFailed = false;
            const startedAt = Date.now();
            // Reuse Insubuy's endpoint and response contract; leave the form/DocuSign mounted.
            return this.$http.get(this.sessionOptions.continueUrl, {
                params: { sessionContext: this.sessionOptions.context }
            }).then(response => {
                this.sessionExtending = false;
                if (response.ok && response.body && response.body.status === 'success') {
                    this.resetRegistrationSession(startedAt);
                } else {
                    this.sessionExtensionFailed = true;
                }
            }, response => {
                this.sessionExtending = false;
                if (response.status === 401) {
                    this.logoutRegistration();
                    return;
                }
                this.sessionExtensionFailed = true;
            });
        }
    }
};
}

export const DashboardSession = createSessionMixin(true);
export default createSessionMixin();
